import React, { Component } from 'react';
import styles from "./index.module.scss";
import { brandIntroTypes } from '@/config/config';

class index extends Component {
  render() {
    return (
      <div>
        <div className={`${styles.banner} ${styles.top_banner}`}>
          <img
            className={styles.banner_img}
            src="/images/top_banner.jpg"
            alt="banner"
          />
        </div>
        <div className={styles.intro_container}>
          <span>
            雅集初创于2009年，隶属于杭州雅集茶具有限公司，是一个专为茶设计美物的手作品牌。雅集以打造现代人的茶生活美学为中心，以成就茶味为目的，倡导专茶专器的原创设计，品牌目前已拥有相关专利两百余项。从为茶设计，到为茶而生，雅集希望将来能为每一类茶叶研发出它的专属冲泡器具，让每一位热爱生活的人爱上茶的味道。
          </span>
        </div>
        <div className={styles.advantage_container}>
          {
            brandIntroTypes.map(item => (
              <div className={styles.advantage}>
                <div className={styles.title_container}>
                  <div className={styles.title}>{item.title}</div>
                  <div className={styles.desc}>{item.desc}</div>
                </div>
                <div className={styles.desc_container}>
                  <div>{item.introduction}</div>
                </div>
              </div>
            ))
          }
        </div>
        <div className={styles.app_footer}>
          <div className={styles.app_img_container}>
            <img src="/images/logo.png" alt=""/>
          </div>
          <div className={styles.app_info_container}>
            <div className={styles.app_info}>
              <div>杭州雅集茶具有限公司</div>
              <a href="http://beian.miit.gov.cn" target="_black" style={{ color: 'rgba(0, 0, 0, .65)' }}>浙ICP备11028005号-2</a>
            </div>
            <div className={styles.app_info}>
              <div>雅集专线:0571-86551555</div>
              <div>浙公网安备 33010802004971号</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default index;
